<template>
  <div>
      <div
          id="select-devices">
        <div>
          <label>Microphone</label>
          <b-form-select
              v-model="selectedAudio"
              :options="optsAudio"
          />
          <br />
        </div>
        <div>
          <label>Speakers</label>
          <b-form-select
              v-model="selectedAudio"
              :options="optsAudio"
          />
          <br />
        </div>
      </div>
  </div>
</template>

<script>
import { PreviewPublisher } from "@vonage/video-express";
export default {
  name: "Sessions_Stage_Settings_Modal",
  components: {},
  props: {
    session: {
      type: Object,
      default: () => {}
    },
    profile: {
      type: Object,
      default: () => {}
    },
    avResources: {
      type: Object,
      default: () => {}
    },
  },
  mounted() {},
  computed: {
  },
  methods: {
    /* PREVIEWING*/
    handleStartPreview() {
      this.previewPublisher = new PreviewPublisher("previewContainer");
      let pubProps = {
        resolution: "1280x720",
        [this.selectedAudio === "" ? "publishAudio" : "audioSource"]:
            this.selectedAudio === "" ? false : this.selectedAudio,
        [this.selectedVideo === "" ? "publishVideo" : "videoSource"]:
            this.selectedVideo === "" ? false : this.selectedVideo,
        mirror: false,
        audioBitrate: 15,
        audioFallbackEnabled: true
      };
      this.previewPublisher.previewMedia({
        targetElement: "myPreviewVideo",
        publisherProperties: pubProps
      });
    },
  },
  data() {
    return {
      optsAudio: this.avResources && this.avResources.optsAudio ?  this.avResources.optsAudio : [],
      optsVideo: this.avResources && this.avResources.optsAudio ?  this.avResources.optsAudio : [],
      selectedAudio:  this.avResources && this.avResources.selectedAudio ?  this.avResources.selectedAudio :
          null,
      selectedVideo:  this.avResources && this.avResources.selectedVideo ?  this.avResources.selectedVideo :
          null,
      previewPublisher: null,
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
